import React from "react";
import { personas } from "../../data/mockData";
import { Building2, Rocket, Code, Check, ArrowRight, Megaphone, Layout, Video } from "lucide-react";
import { SiFacebook, SiTiktok } from "react-icons/si";

const personaIcons = {
  building: Building2,
  rocket: Rocket,
  code: Code,
};

// Mini preview cards for each persona
const PersonaPreview = ({ persona }) => {
  const previewContent = {
    agency: [
      { title: "Client A - Q4 Inspiration", items: 12, color: "#3b82f6" },
      { title: "Moodboard Lancement", items: 8, color: "#8b5cf6" },
      { title: "Concurrents - Veille", items: 24, color: "#ef4444" },
    ],
    founder: [
      { title: "Hooks qui convertissent", items: 18, color: "#22c55e" },
      { title: "Landing pages SaaS", items: 9, color: "#6366f1" },
      { title: "UGC Testimonials", items: 15, color: "#f59e0b" },
    ],
    developer: [
      { title: "UI Patterns", items: 22, color: "#06b6d4" },
      { title: "Hero Sections", items: 14, color: "#ec4899" },
      { title: "Pricing Pages", items: 11, color: "#84cc16" },
    ],
  };

  const content = previewContent[persona.id] || previewContent.agency;

  return (
    <div className="bg-[#0a0a0c] rounded-xl border border-white/[0.06] p-4 h-full">
      <div className="flex items-center justify-between mb-3">
        <span className="text-[11px] text-white/50">Mes Boards</span>
        <span className="text-[10px] text-white/30">{content.reduce((a, b) => a + b.items, 0)} contenus</span>
      </div>
      <div className="space-y-2">
        {content.map((board, i) => (
          <div key={i} className="flex items-center gap-2.5 py-2 px-2.5 rounded-lg bg-white/[0.02] border border-white/[0.04]">
            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: board.color }} />
            <span className="text-[11px] text-white/70 flex-1 truncate">{board.title}</span>
            <span className="text-[10px] text-white/30">{board.items}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  return (
    <section id="use-cases" className="py-28 relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-[radial-gradient(ellipse_at_center,_rgba(120,80,200,0.04)_0%,_transparent_70%)]" />

      <div className="relative max-w-[1200px] mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-xl mx-auto mb-20">
          <div className="inline-flex items-center gap-2 bg-white/[0.03] border border-white/[0.07] rounded-full px-4 py-1.5 mb-6">
            <span className="text-[11px] text-[#7a7a7a] uppercase tracking-widest font-medium">Pour qui ?</span>
          </div>
          <h2 className="text-3xl md:text-[2.75rem] font-bold text-white tracking-[-0.02em] leading-tight mb-4">
            Conçu pour ceux qui créent.
          </h2>
          <p className="text-[#666] text-base leading-relaxed">
            Que vous soyez freelance, en agence ou indie maker, AllSave s'adapte à votre workflow.
          </p>
        </div>

        {/* Persona Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {personas.map((persona) => {
            const Icon = personaIcons[persona.icon];
            return (
              <div
                key={persona.id}
                className="group rounded-2xl border border-white/[0.06] bg-[#0a0a0c] overflow-hidden hover:border-white/[0.12] transition-all duration-500"
              >
                {/* Gradient header */}
                <div className={`h-2 bg-gradient-to-r ${persona.color}`} />
                
                <div className="p-7">
                  {/* Icon and title */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-10 h-10 rounded-xl bg-white/[0.05] border border-white/[0.08] flex items-center justify-center ${persona.accentColor}`}>
                      {Icon && <Icon size={18} />}
                    </div>
                    <div>
                      <h3 className="text-white font-semibold text-[15px]">{persona.title}</h3>
                      <p className="text-[#555] text-[11px]">{persona.subtitle}</p>
                    </div>
                  </div>

                  <p className="text-[#777] text-[13px] leading-relaxed mb-5">
                    {persona.description}
                  </p>

                  {/* Benefits */}
                  <div className="space-y-2.5 mb-6">
                    {persona.benefits.map((benefit, i) => (
                      <div key={i} className="flex items-start gap-2.5">
                        <div className="w-4 h-4 rounded-full bg-white/[0.05] flex items-center justify-center shrink-0 mt-0.5">
                          <Check size={9} className="text-emerald-400" />
                        </div>
                        <span className="text-[12px] text-[#888]">{benefit}</span>
                      </div>
                    ))}
                  </div>

                  {/* Mini preview */}
                  <PersonaPreview persona={persona} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
